var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRipple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 218.23 95.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#b3b3b3;}.cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.cls-2{stroke:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.57,28.12C21.52,18.99,38.25,11.49,58.98,6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.29,82.34C15.74,73.89,1.5,61.47,1.5,47.62c0-2.18,.35-4.33,1.04-6.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.71,93.63c-2.51,.07-5.04,.11-7.59,.11-12.98,0-25.43-.99-36.95-2.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.63,76.18c-13.29,7.21-31.5,12.68-52.45,15.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.06,11.51c24.79,8.45,40.68,21.49,40.68,36.11,0,2.38-.42,4.72-1.24,7.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.06,2.15c5.87-.43,11.91-.65,18.06-.65,10.41,0,20.47,.63,29.99,1.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.16,76.25c-7.66-.6-14.98-1.77-21.83-3.42-18.64-4.5-33.77-12.59-42.49-22.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.79,76.57c-3.95,0-7.83-.11-11.63-.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.72,14.83c30.36,4.67,51.85,16.24,51.85,29.77,0,10.18-12.17,19.26-31.14,25.11-4.78,1.48-10,2.75-15.56,3.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.17,29.88c12.55-9.46,36.83-16.15,65.3-17.14,2.41-.08,4.85-.13,7.32-.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.93,33.58c6.08-3.96,15.44-7.07,26.61-8.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.08,64.26c-22.32-2.46-38.69-10.48-38.69-20,0-.93,.16-1.85,.46-2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.28,28.89c10.68,3.8,17.39,9.28,17.39,15.37,0,9.18-15.22,16.97-36.32,19.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.84,22.4c6.22,.26,12.02,.98,17.19,2.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.8,34.26c1.22-.13,2.49-.22,3.78-.26,11.39-.38,20.75,2.93,20.9,7.38,.15,4.46-8.97,8.37-20.36,8.75-11.39,.38-20.75-2.93-20.9-7.38"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipple);
export default __webpack_public_path__ + "static/media/Ripple.36d4452ab86100d2230ec179918fccb0.svg";
export { ForwardRef as ReactComponent };